import { Component, Input, Output, EventEmitter, HostBinding } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-selectable-card',
  templateUrl: './selectable-card.component.html',
  styleUrls: ['./selectable-card.component.scss']
})
export class SelectableCardComponent {
  @Input() value: any;
  @Input() label: string = '';
  @Input() description: string = '';
  @Input() selected: boolean = false;
  @Input() icon: string = '';
  @Input() svgIcon: string = '';
  @Input() disabled: boolean = false;

  @Output() selectionChange = new EventEmitter<any>();

  constructor(private sanitizer: DomSanitizer) {}

  get sanitizedDescription(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.description || '');
  }

  get sanitizedSvgIcon(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.svgIcon || '');
  }

  @HostBinding('class.selected') get isSelected(): boolean {
    return this.selected;
  }

  @HostBinding('class.disabled') get isDisabled(): boolean {
    return this.disabled;
  }

  @HostBinding('attr.role') role = 'radio';
  @HostBinding('attr.aria-checked') get ariaChecked(): boolean {
    return this.selected;
  }

  @HostBinding('attr.aria-disabled') get ariaDisabled(): boolean {
    return this.disabled;
  }

  onClick(): void {
    if (!this.disabled) {
      this.selectionChange.emit(this.value);
    }
  }
}
